import * as _ from "lodash"
import { updateVariants } from "../../logic/updateVariants"

const sortPrestationsLowestToHighestPrice = (prestations) => {
	if (prestations.length === 0) return prestations
	const sorted = [...prestations]
	sorted.sort((a, b) => {
		return (
			parseInt(a.variants[0].pricePerLogement) -
			parseInt(b.variants[0].pricePerLogement)
		)
	})
	return sorted
}

const removeDuplicates = (prestations) => {
	prestations.forEach((prest) => {
		const map = {}
		prest.variants.forEach((variant) => {
			map[variant.id] = variant
		})
		prest.variants = Object.values(map).sort(
			(a, b) => a.pricePerLogement > b.pricePerLogement
		)
	})
	return prestations
}

// Function to filter images based on prestIdSource
function filterImagesByPrestIdSource(prestIdSources) {
	if(!prestIdSources && !prestIdSources.length) {
		console.error("filterImagesByPrestIdSource error ~ no prestIdSources")
		return window.prestImages
	}
	
	const images = window.prestImages
    return images.map(image => {
        const keys = Object.keys(image);
        const filteredKeys = keys.filter(key => 
            typeof image[key] === 'string' && 
            prestIdSources.some(id => image[key].includes(id))
        );

        return filteredKeys.reduce((obj, key) => {
            obj[key] = image[key];
            return obj;
        }, {});
    }).filter(image => Object.keys(image).length > 0);
}


const buildAvailableGalleryImages = (prestations) => {
	const liheImagesBasedOnSeason = window.seasonManager.isSummer() ? window.lihe.picturesLodgingSummer : window.lihe.picturesLodgingWinter

	if(!prestations || !prestations.length) {
		console.error("buildAvailableGalleryImages error ~ no prestations")
		return window.srcObjectArray || liheImagesBasedOnSeason
	} 

	const prestIdSources = prestations.flatMap(prestation => 
		prestation.variants.map(variant => variant.prestIdSource)
	);

	if(!prestIdSources || !prestIdSources.length) {
		console.error("buildAvailableGalleryImages error ~ no prestIdSources")
		return window.srcObjectArray
	} 

	const filteredImages = filterImagesByPrestIdSource(prestIdSources)

	if(!filteredImages || !filteredImages.length) {
		console.error("buildAvailableGalleryImages error ~ no filteredImages")
		return window.srcObjectArray
	} 

	const availableImages = [...liheImagesBasedOnSeason, ...filteredImages].map((obj => {
		return {
		  ...obj,
		  type: 'image'
		}
	}))

	return availableImages
}

const emitBuiltImagesEvent = () => {
	window.dispatchEvent(new Event("availableImagesBuilt"))
}



export default {
	prestations: (state) => {

		let prestations = []
		
		window.lihe.availablePrestations = prestations
		if (state.loading) {
			window.srcObjectArray = buildAvailableGalleryImages(prestations)
			window.dispatchEvent(new Event("availableImagesBuilt"))
			return prestations

		}

		// get prestation arrays
		const initialPrestations = _.cloneDeep(state.initialPrestationsArray)
		// get maps
		const availabilityPrestationsMap = _.cloneDeep(
			state.prestMaps.seAvailabilities[state.packCode]
		)
		const quotePrestationsMap = _.cloneDeep(
			state.prestMaps.prices[state.packCode] || null
		)

		// Check for availability.
		// The same prestation can be in several packages, so
		// an availability prestation is enriched with initial prestation info
		if (
			!availabilityPrestationsMap ||
			Object.keys(availabilityPrestationsMap).length === 0
		) {
			window.lihe.availablePrestations = prestations
			return prestations
		}

		try {
			prestations = initialPrestations
				.map((initialPrest) => {
					initialPrest["criteriasSet"] = new Set(initialPrest.criterias)
					initialPrest["variants"] = []

					// check if prestationId matches prestIdSource
					Object.values(availabilityPrestationsMap).forEach((availPrest) => {
						availPrest["totalMaxCapacity"] =
							availPrest.quantity * availPrest.maxCapacity

						// if source id matches initial prest id
						if (initialPrest.prestationId === availPrest.prestIdSource) {
							initialPrest["variants"].push(availPrest)
						}
					})

					// for variants from previous loop, add variants that have the same prestIdFusion but different unique id (pv flex case)
					const variantsToAdd = []
					initialPrest["variants"].forEach((variant) => {
						const sameFusionIdPrestation = Object.values(
							availabilityPrestationsMap
						).find((availPrest) => {
							return (
								availPrest.prestIdFusion === variant.prestIdFusion &&
								availPrest.id !== variant.id
							)
						})
						if (sameFusionIdPrestation)
							variantsToAdd.push(sameFusionIdPrestation)
					})

					initialPrest["variants"] = [
						...initialPrest["variants"],
						...variantsToAdd,
					]
					

					if (initialPrest["variants"].length === 0) {
						return
					}
					return initialPrest
				})
				.filter((_) => _)
		} catch (err) {
			console.error(err)
		}

		// update / enrich with quote prices
		if (!quotePrestationsMap || Object.keys(quotePrestationsMap).length === 0) {
			// why do we have this case ?
		} else {
			try {
				// Precompute totalMaxCapacity for all quotePrestations.
				Object.values(quotePrestationsMap).forEach((quotePrest) => {
					quotePrest["totalMaxCapacity"] =
						quotePrest.quantity * quotePrest.maxCapacity
				})

				// Create a map for direct access.
				const quotePrestMap = {}
				Object.values(quotePrestationsMap).forEach((quotePrest) => {
					quotePrestMap[quotePrest.id] = quotePrest
				})

				prestations = prestations
					.map((prest) => {
						prest["variants"] = prest["variants"]
							.map((variant) => {
								const quotePrest = quotePrestMap[variant.id]
								if (quotePrest) {
									// Remove keys that do no exist in the quotePrest.
									const quotePrestFieldsSet = new Set(Object.keys(quotePrest))
									Object.keys(variant).forEach((field) => {
										if (!quotePrestFieldsSet.has(field)) {
											delete variant[field]
										}
									})

									// Assign all the keys of the variant to the values of the quotePrest.
									Object.assign(variant, quotePrest)
								}
								return variant
							})
							.filter(Boolean) // Using `Boolean` is a concise way to filter out falsy values.
						return prest
					})
					.filter(Boolean)
			} catch (err) {
				console.error(err)
			}
		}

		prestations = removeDuplicates(prestations)
		prestations = sortPrestationsLowestToHighestPrice(prestations)
		// prestations = process_CS_packages(prestations, state.content)

		window.srcObjectArray = buildAvailableGalleryImages(prestations)
		window.lihe.availablePrestations = prestations
		emitBuiltImagesEvent()
		window.availablePrests = prestations


		const enrichedPrestations = prestations.map(prest => {
			return {
				...prest,
				variants: prest.variants.length > 1 ? updateVariants(prest.variants) : prest.variants
			}
		})
		return enrichedPrestations
	},

	variants: (state, getters) => {
		const prestations = _.cloneDeep(getters.prestations)
		let variants = []

		prestations.forEach((prest) => {
			variants = [...variants, ...prest.variants]
		})

		const updatedVariants = updateVariants(variants) 
		
		return updatedVariants.length > 1 ? updatedVariants : variants
	},

	cheapestPrestationIndex: (state, getters) => {
		const prestations = getters.prestations
		let cheapestPrestationIndex
		let currentCheapestPrice
		prestations.forEach((prest, prest_i) => {
			prest.variants.forEach((variant) => {
				const pricePerLogement = variant.pricePerLogement
				if (!currentCheapestPrice) {
					cheapestPrestationIndex = prest_i
					currentCheapestPrice = pricePerLogement
				} else if (currentCheapestPrice > pricePerLogement) {
					currentCheapestPrice = pricePerLogement
				}
			})
		})

		return cheapestPrestationIndex
	},
}
